import { render, staticRenderFns } from "./CMAttachmentsImport.vue?vue&type=template&id=19633620&scoped=true&"
import script from "./CMAttachmentsImport.vue?vue&type=script&lang=js&"
export * from "./CMAttachmentsImport.vue?vue&type=script&lang=js&"
import style0 from "./CMAttachmentsImport.vue?vue&type=style&index=0&id=19633620&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19633620",
  null
  
)

export default component.exports